/**
 * @packageDocumentation
 * @module f1/number
 */

import to_integer from '../to/to_integer';

export interface Ceiling {
  /**
   * Raise a real to the next highest integer value
   *
   * @public
   * @function f1.ceiling
   * @param v a real number
   * @example
   *
   * ```ts
   * ceiling(3.01) === 4
   * ```
   */
  (v: number): number;
}

/**
 * @see Ceiling
 */
export default (v: number): number => to_integer(v + 1.0);
